const logicalOperator = {
    or: 'Or',
    and: 'And'
};

export default logicalOperator;
